import React, { useEffect, useRef } from "react";
import Globe from "globe.gl";

export default function GlobeComponent({ onCountryClick }) {
  const globeRef = useRef();

  useEffect(() => {
    const container = globeRef.current;

    // Initialize globe
    const globe = Globe()(container)
      .globeImageUrl('//unpkg.com/three-globe/example/img/earth-dark.jpg')
      .polygonCapColor(() => 'rgba(0,255,0,0.4)')
      .polygonSideColor(() => 'rgba(0,255,0,0.1)')
      .polygonStrokeColor(() => '#0f0')
      .onPolygonClick(polygon => {
        if (polygon.properties && polygon.properties.name) {
          onCountryClick(polygon.properties.name);
        }
      })
      .pointOfView({ lat: 20.5937, lng: 78.9629, altitude: 2 }); // India coordinates

    // Load countries
    fetch("https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/world.geojson")
      .then(res => res.json())
      .then(data => globe.polygonsData(data.features));

    // Make globe responsive
    const resizeObserver = new ResizeObserver(() => {
      globe.width([container.offsetWidth]);
      globe.height([container.offsetHeight]);
    });
    resizeObserver.observe(container);

    return () => resizeObserver.disconnect();
  }, [onCountryClick]);

  return <div ref={globeRef} style={{ width: '100%', height: '100%' }} />;
}
